<template>
  <div class="register absolute">
    <div class="register_tit">
      <img @click="$router.go(-1)" src="../../assets/images/licai/fanhui.png" />
      <p class="">{{ $t("m.xiangqing") }}</p>
    </div>
    <div class="register_block">
      <div class="home_swiper">
        <swiper :options="swiperOption">
          <swiper-slide
            style="width: 100%"
            v-for="(item, index) in dicdata.images"
            :key="index"
          >
            <img class="banner_img" :src="item" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        <!-- <div style="z-index: 10; position: absolute;right:20px;bottom:20px;background:#eee;border-radius:4px;text-align:center;color:#666;width: 60px;height: 26px;line-height:26px;opacity:0.9;">
          1/5
        </div> -->
      </div>
      <div style="padding: 10px 10px; background: #fff">
        <div style="font-size: 16px; font-weight: blod">
          {{ dicdata.title }}
        </div>
        <div
          style="
            margin: 10px 0;
            background: #eee;
            border-radius: 4px;
            text-align: center;
            color: #666;
            padding: 0 10px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            display: inline-block;
          "
        >
          {{ dicdata.desc }}
        </div>
        <div style="color: #666; font-size: 13px">
          <span
            style="font-size: 20px; color: var(--bg-color); font-weight: bold"
            >{{ dicdata.price }} </span
          >{{ $t("m.dj_span5") }}
        </div>
      </div>
      <div style="padding: 10px 10px; background: #fff; margin-top: 10px">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            height: 22px;
          "
        >
          <span>{{ $t("m.jf_span5") }}</span>
          <span style="color: #666">{{ dicdata.sketch }}</span>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            height: 46px;
          "
        >
          <span>{{ $t("m.jf_span6") }}</span>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 14px;
            "
          >
            <div @click="jian">-</div>

            <input
              style="
                text-align: center;
                background: #eee;
                border-radius: 4px;
                width: 60px;
                height: 24px;
                margin: 0 6px;
              "
              type="number"
              v-model="num1"
            />
            <div @click="jia">+</div>
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            height: 22px;
          "
        >
          <span>{{ $t("m.jf_span7") }}</span>
          <input
            type="text"
            style="text-align: right"
            v-model="bz"
            :placeholder="$t('m.jf_span8')"
          />
        </div>
      </div>
      <div
        style="
          padding: 10px 10px;
          background: #fff;
          margin-top: 10px;
          font-size: 14px;
          padding-bottom: 100px;
        "
      >
        <div>{{ $t("m.jf_span10") }}</div>
        <div v-html="dicdata.content"></div>
      </div>
    </div>

    <div
      @click="lidh"
      style="
        border-radius: 4px 4px 0 0;
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        height: 54px;
        line-height: 54px;
        background: var(--bg-color);
        color: #fff;
        font-weight: blod;
        font-size: 17px;
        text-align: center;
      "
    >
      {{ $t("m.jf_span9") }}
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
export default {
  name: "JfList",
  data: function() {
    return {
      num1: "1",
      bz: "",
      dicdata: {},
      swiperOption: {
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination"
        }
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  mounted: function() {
    let type = this.$route.params.id;
    request
      .get("/shop/goods/good-detail", { id: type }, { login: true })
      .then(res => {
        console.log(res);
        this.dicdata = res.data.data;
      })
      .catch(err => {
        this.$dialog.error(err.response.data.msg);
      });
  },
  methods: {
    jia() {
      this.num1++;
    },
    jian() {
      if (this.num1 <= 1) {
        return;
      }
      this.num1--;
    },
    lidh() {
      let type = this.$route.params.id;
      localStorage.setItem(
        "jifen",
        JSON.stringify({ num: this.num1, bz: this.bz })
      );
      this.$router.push({
        path: "/JfPay/" + type
      });
    }
  }
};
</script>
<style scoped>
.line-clamp2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.home_swiper {
  width: 100%;
  height: 400px;
  position: relative;
}

.home_swiper swiper-slide {
  width: 100%;
  height: 100%;
}

.banner_img {
  width: 100%;
  height: 400px;
}
.register_submit {
  width: 92%;
  margin: 80px auto 0 auto;

  height: 50px;
  background: #1664fc;
  border-radius: 5px;
  margin-top: 80px !important;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 16px;
}
.register_block {
  margin-top: 45px;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 15px;
}
.register_code_lists {
  border: 1px solid #007aff;
  text-align: center;
  color: #007aff;
  border-radius: 6px;
  width: 36%;
  height: 45px;
  margin-left: 15px;
  line-height: 45px;
}
.register_code_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.register_code {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>
